import styled from 'styled-components'

const PageHeaderPlato = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 3rem;
  padding-top: 1em;
  margin-bottom: .75rem;

  & > h1{
    margin-left: 1.5rem;
  }
`

export default PageHeaderPlato